module.exports = __webpack_public_path__ + "fonts/303a293f207127f2d21561491c3a71c4.svg";